module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    c:  { default: 'default' }    # collection name
    i:  { default: null }         # item name

  methods:

    onClick: ->
      @.$store.dispatch('accordion/toggle', { collection: @c, id: @i })


// WEBPACK FOOTER //
// ./assets/js/frontend/components/accordion_toggle/index.coffee